import Styles from './UploadsDrawer.module.scss'
import { useUploadsTab } from '../UploadsTabContext'
import { Carousel } from 'components/Carousel/Carousel'
import { MediaFile } from '../MediaFile'
import { UnsplashImg, useUnsplashPhotos } from '../useUnsplashPhotos'
import { insertImage } from '../insertImage'
import { useCompleteDesignAction } from '../../utils/useCompleteDesignAction'
import { useRootStore } from 'stores/RootStore'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { DesignActionType } from 'types'
import { SectionHeader } from './SectionHeader'
import { LoadingCarousel } from './LoadingCarousel'
import { createBackground } from 'components/Design/BackgroundsTab/createBackground'

export const StockPhotos = () => {
  const editor = useEditor()
  const { openPanel, forBackground } = useUploadsTab()
  const { results, isLoading } = useUnsplashPhotos({ query: '' })
  const completeActionMutation = useCompleteDesignAction()
  const { drawersStore } = useRootStore()

  const handleOnPress = (result: UnsplashImg) => {
    if (forBackground && result.width && result.height) {
      createBackground(editor, {
        src: result.regular,
        w: result.width,
        h: result.height,
        mimeType: 'image/png',
      })
      drawersStore.resetSnap()

      return
    }

    insertImage(editor, {
      id: result.regular,
      source_url: result.regular,
      mime_type: 'image/png',
      width: result.width,
      height: result.height,
      variants: [],
    })
    completeActionMutation.mutate({ action: DesignActionType.CoreImage })
    drawersStore.closeDrawer()
  }
  return (
    <div>
      <SectionHeader title="Stock Photos" onPress={() => openPanel({ panel: 'photos', panelProps: {} })} />
      <div className={Styles.sectionContainer}>
        {isLoading && <LoadingCarousel />}
        {!isLoading && (
          <Carousel slideGap={7}>
            {results.slice(0, 6).map((result, index) => (
              <div key={index} className={Styles.mediaFileContainer}>
                <MediaFile
                  key={result.thumb}
                  aria-label="Add this photo to the canvas"
                  src={result.thumb}
                  file={{
                    id: result.regular,
                    source_url: result.regular,
                    mime_type: 'image/png',
                    width: result.width,
                    height: result.height,
                    variants: [],
                    title: result.regular,
                  }}
                  size={{ height: 100, width: 100 }}
                  onPress={() => handleOnPress(result)}
                />
              </div>
            ))}
          </Carousel>
        )}
      </div>
    </div>
  )
}
